import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/claudecode.png'
import _imports_1 from '../assets/img/codex.jpg'
import _imports_2 from '../assets/img/vuejs.png'
import _imports_3 from '../assets/img/react.svg'
import _imports_4 from '../assets/img/springboot.png'
import _imports_5 from '../assets/img/go.png'
import _imports_6 from '../assets/img/mongodb.png'
import _imports_7 from '../assets/img/postgresql_elephant.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-32799242"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapping" }
const _hoisted_2 = { class: "item-title" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["textContent"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["textContent"]
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"logo-items\" data-v-32799242><div class=\"img-dev\" data-v-32799242><img src=\"" + _imports_0 + "\" data-v-32799242></div><div class=\"img-dev\" data-v-32799242><img src=\"" + _imports_1 + "\" data-v-32799242></div><div class=\"img-dev\" data-v-32799242><img src=\"" + _imports_2 + "\" data-v-32799242></div><div class=\"img-dev\" data-v-32799242><img src=\"" + _imports_3 + "\" data-v-32799242></div><svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" width=\"50\" viewBox=\"0 0 128 128\" data-v-32799242><rect fill=\"#3178c6\" height=\"128\" rx=\"6\" width=\"128\" data-v-32799242></rect><path clip-rule=\"evenodd\" d=\"m74.2622 99.468v14.026c2.2724 1.168 4.9598 2.045 8.0625 2.629 3.1027.585 6.3728.877 9.8105.877 3.3503 0 6.533-.321 9.5478-.964 3.016-.643 5.659-1.702 7.932-3.178 2.272-1.476 4.071-3.404 5.397-5.786 1.325-2.381 1.988-5.325 1.988-8.8313 0-2.5421-.379-4.7701-1.136-6.6841-.758-1.9139-1.85-3.6159-3.278-5.1062-1.427-1.4902-3.139-2.827-5.134-4.0104-1.996-1.1834-4.246-2.3011-6.752-3.353-1.8352-.7597-3.4812-1.4975-4.9378-2.2134-1.4567-.7159-2.6948-1.4464-3.7144-2.1915-1.0197-.7452-1.8063-1.5341-2.3598-2.3669-.5535-.8327-.8303-1.7751-.8303-2.827 0-.9643.2476-1.8336.7429-2.6079s1.1945-1.4391 2.0976-1.9943c.9031-.5551 2.0101-.9861 3.3211-1.2929 1.311-.3069 2.7676-.4603 4.3699-.4603 1.1658 0 2.3958.0877 3.6928.263 1.296.1753 2.6.4456 3.911.8109 1.311.3652 2.585.8254 3.824 1.3806 1.238.5552 2.381 1.198 3.43 1.9285v-13.1051c-2.127-.8182-4.45-1.4245-6.97-1.819s-5.411-.5917-8.6744-.5917c-3.3211 0-6.4674.3579-9.439 1.0738-2.9715.7159-5.5862 1.8336-7.844 3.353-2.2578 1.5195-4.0422 3.4553-5.3531 5.8075-1.311 2.3522-1.9665 5.1646-1.9665 8.4373 0 4.1785 1.2017 7.7433 3.6052 10.6945 2.4035 2.9513 6.0523 5.4496 10.9466 7.495 1.9228.7889 3.7145 1.5633 5.375 2.323 1.6606.7597 3.0954 1.5486 4.3044 2.3668s2.1628 1.7094 2.8618 2.6736c.7.9643 1.049 2.06 1.049 3.2873 0 .9062-.218 1.7462-.655 2.5202s-1.1 1.446-1.9885 2.016c-.8886.57-1.9956 1.016-3.3212 1.337-1.3255.321-2.8768.482-4.6539.482-3.0299 0-6.0305-.533-9.0021-1.6-2.9715-1.066-5.7245-2.666-8.2591-4.799zm-23.5596-34.9136h18.2974v-11.5544h-51v11.5544h18.2079v51.4456h14.4947z\" fill=\"#fff\" fill-rule=\"evenodd\" data-v-32799242></path></svg></div><div class=\"logo-items\" data-v-32799242><div class=\"img-dev\" data-v-32799242><img src=\"" + _imports_4 + "\" data-v-32799242></div><div class=\"img-dev\" data-v-32799242><img src=\"" + _imports_5 + "\" data-v-32799242></div><div class=\"img-dev\" data-v-32799242><img src=\"" + _imports_6 + "\" data-v-32799242></div><div class=\"img-dev\" data-v-32799242><img src=\"" + _imports_7 + "\" data-v-32799242></div></div>", 2)

import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AboutUs',
  props: ['translate'],
  setup(__props) {

const props = __props 

// About Us
const aboutUsEn = ref(`We
           specializes in developing web systems for businesses and organizations. 
           We provide systems and services that enhance operational 
           efficiency and support business growth. With strong technical expertise and flexible solutions, 
           we offer tailored approaches to meet your specific needs.`)
const aboutUsJa = ref(`企業様や団体様向けのWebシステム開発を専門に行う会社です。お客様の業務効率を高めるためのシステムやサービスを提供し、
            ビジネスの成長をサポートします。私たちは、技術力と柔軟な対応力を強みに、最適なソリューションを提案します。`);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (props.translate)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, "当社について"))
        : (_openBlock(), _createElementBlock("p", _hoisted_4, "About Us"))
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(props.translate ? 'item-detail' : 'item-detail-en')
    }, [
      (props.translate)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("p", {
              textContent: _toDisplayString(aboutUsJa.value)
            }, null, 8, _hoisted_6)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("p", {
              textContent: _toDisplayString(aboutUsEn.value)
            }, null, 8, _hoisted_8)
          ])),
      _hoisted_9
    ], 2)
  ]))
}
}

})